import {
  buildProjectBadgeFrameSx,
  buildProjectBadgeTextSx,
  resolveProjectBadgeDisplayChars,
  type ProjectBadgeSize,
} from '@/features/projects/components/ProjectBadge.styles';
import { Box } from '@/ui/primitives';
import type { ProjectDto } from '@flowqa/shared';
import type { ReactElement } from 'react';

type ProjectBadgeProps = {
  chars: string;
  color: ProjectDto['badgeColor'];
  disabled?: boolean;
  size?: ProjectBadgeSize;
};

export const ProjectBadge = ({
  chars,
  color,
  disabled = false,
  size = 'default',
}: ProjectBadgeProps): ReactElement => {
  const displayChars = resolveProjectBadgeDisplayChars(chars);
  const isCompactText = displayChars.length > 1;

  return (
    <Box sx={buildProjectBadgeFrameSx({ color, disabled, size })}>
      <Box component="span" sx={buildProjectBadgeTextSx({ compactText: isCompactText, size })}>
        {displayChars}
      </Box>
    </Box>
  );
};
